import axios from 'axios'

export const reports = {
    state: {
      NumberOfMembers:{},
      NumberOfCars:{},
      Transactions:{},
      SummaryReport:{},
      ClaimMonthsAmount:[],
      PremiumMonthsAmount:[],
      MemberYearlyReport:[],
      CarByStatus:[],
      CarsCount:0,

    },
    mutations:{
      setMembers(state, data){
        state.NumberOfMembers= data
      },
      setSummary(state, data){
        state.SummaryReport= data
      },
      setCars(state, data){
        state.NumberOfCars = data
      },
      setCarsCount(state, data){
        state.CarsCount = data.count
      },
      setClaimMonths(state, data){
        state.ClaimMonthsAmount = data
      },
      setPremiumMonths(state, data){
        state.PremiumMonthsAmount = data
      },
      setTransactions(state, data){
        state.Transactions = data
      },
      setMemberYearlyReport(state, data){
        state.MemberYearlyReport = data
      },
      setCarStatus(state, data){
        state.CarByStatus = data
      },
      setClearClaimPremium(state, data){
        state.ClaimMonthsAmount=data,
        state.PremiumMonthsAmount=data
      }
    }, 
    actions:{
      getMembersReport: ({commit})=>{
          return new Promise((resolve, reject)=>{
              axios.get("/numberOfMembers/reports")
              .then(({status, data})=>{
                if(status === 200){
                  resolve(data);
                  commit("setMembers", data)
                }
              })
              .catch((error)=>{
                reject(error);
              });
            })
      },
      getMembersReportFilter: ({commit}, payload)=>{
          return new Promise((resolve, reject)=>{
              if(!payload.status){
                  axios.get(`/numberOfMembers/reports?from=${payload.from}&to=${payload.to}`)
                  .then(({status, data})=>{
                  if(status === 200){
                      resolve(data);
                      commit("setMembers", data)
                  }
                  })
                  .catch((error)=>{
                  reject(error);
                  });
              }else{
                  axios.get(`/numberOfMembers/reports?from=${payload.from}&to=${payload.to}&status=${payload.status}`)
                  .then(({status, data})=>{
                  if(status === 200){
                      resolve(data);
                      commit("setMembers", data)
                  }
                  })
                  .catch((error)=>{
                  reject(error);
                  });
              }
              
            })
      },
      getCarsReport: ({commit}, payload)=>{
        return new Promise((resolve, reject)=>{
          axios.get(`/numberOfCars/reports?status=${payload.status}&isExpired=${payload.isExpired}`)
          .then(({status, data})=>{
            if(status === 200){
              resolve(data);
              commit("setCars", data)
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      getCarsCount: ({commit})=>{
        return new Promise((resolve, reject)=>{
          axios.get('/numberOfCars/reports')
          .then(({status, data})=>{
            if(status === 200){
              resolve(data);
              commit("setCarsCount", data)
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      getCarsReportFilter: ({commit}, payload)=>{
          return new Promise((resolve, reject)=>{
              axios.get(`/numberOfCars/reports?from=${payload.from}&to=${payload.to}&status=${payload.status}&isExpired=${payload.isExpired}`)
              .then(({status, data})=>{
                if(status === 200){
                  resolve(data);
                  commit("setCars", data)
                }
              })
              .catch((error)=>{
                reject(error);
              });
          })
      },
      getClaimsAmountWithMonths: ({commit})=>{
        return new Promise((resolve, reject)=>{
            axios.get("/claimsPayment/reports")
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
                commit("setClaimMonths", data)
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
      },
      getPremiumAmountWithMonths: ({commit})=>{
        return new Promise((resolve, reject)=>{
            axios.get("/premiumPayment/reports")
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
                commit("setPremiumMonths", data)
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
      },
      getClaimsAmountWithMonthsFilter: ({commit}, payload)=>{
        let dat = []
        commit("setClearClaimPremium", dat)
        return new Promise((resolve, reject)=>{
            axios.get(`/claimsPayment/reports?from=${payload.from}&to=${payload.to}`)
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
                commit("setClaimMonths", data)
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
      },
      getPremiumAmountWithMonthsFilter: ({commit}, payload)=>{
        return new Promise((resolve, reject)=>{
            axios.get(`/premiumPayment/reports?from=${payload.from}&to=${payload.to}`)
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
                commit("setPremiumMonths", data)
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
      },
      getTransactions: ({commit}, payload)=>{
        return new Promise((resolve, reject)=>{
          axios.get(`/transactions/reports?status=${payload.status}`)
          .then(({status, data})=>{
            if(status === 200){
              resolve(data);
              commit("setTransactions", data)
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      getTransactionFilter: ({commit}, payload)=>{
        return new Promise((resolve, reject)=>{
          if(!payload.type){
              axios.get(`/transactions/reports?from=${payload.from}&to=${payload.to}&status=${payload.status}`)
              .then(({status, data})=>{
              if(status === 200){
                  resolve(data);
                  commit("setTransactions", data)
              }
              })
              .catch((error)=>{
              reject(error);
              });
          }else{
            axios.get(`/transactions/reports?from=${payload.from}&to=${payload.to}&status=${payload.status}&type=${payload.type}`)
            .then(({status, data})=>{
            if(status === 200){
              resolve(data);
              commit("setTransactions", data)
            }
            })
            .catch((error)=>{
            reject(error);
            });
          }
          
      })
      },
      getSummary: ({commit})=>{
        return new Promise((resolve, reject)=>{
            axios.get("/reportsummary/reports")
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
                commit("setSummary", data)
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
      },
      getMembersYearlyReport: ({commit})=>{
        return new Promise((resolve, reject)=>{
          axios.get("/membersYearly/reports")
          .then(({status, data})=>{
            if(status === 200){
              resolve(data);
              commit("setMemberYearlyReport", data)
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      getCarsByStatus: ({commit})=>{
        return new Promise((resolve, reject)=>{
          axios.get("/carStatusCount/reports")
          .then(({status, data})=>{
            if(status === 200){
              resolve(data);
              commit("setCarStatus", data)
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
  }
}